import FastClick from 'fastclick';

function init() {
    FastClick.attach(document.body);
}

export { init };




// WEBPACK FOOTER //
// ./src/_app/layout/fastclick.js